import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200/60 transition-all duration-300 flex flex-col">
      <Link to={`/article/${article.slug}`} className="block overflow-hidden">
        <div className="relative w-full aspect-video overflow-hidden bg-background-100">
          <img
            src={article.image}
            alt={article.title}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            title={`${article.title} - 成人网站安全指南`}
          />
        </div>
      </Link>
      <div className="flex flex-col flex-1 p-4 md:p-5">
        <div className="flex items-center gap-2 mb-3 flex-wrap">
          <span className="text-xs font-medium text-primary-700 bg-primary-100/80 px-2.5 py-1 rounded-full whitespace-nowrap">
            {article.category === 'safe-access' ? '安全访问' :
             article.category === 'privacy-protection' ? '隐私保护' :
             article.category === 'content-filtering' ? '内容分级' :
             article.category === 'compliance' ? '合规使用' :
             article.category === 'family-safety' ? '家庭防护' : '数字健康'}
          </span>
          <span className="text-xs text-foreground-400">{article.readTime}</span>
        </div>
        <Link to={`/article/${article.slug}`} className="block mb-2">
          <h3 className="text-base font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200 font-heading">
            {article.title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-600 line-clamp-2 mb-4 flex-1">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between">
          <span className="text-xs text-foreground-400">{article.date}</span>
          <Link
            to={`/article/${article.slug}`}
            className="text-sm font-medium text-primary-600 hover:text-primary-700 flex items-center gap-1 whitespace-nowrap transition-colors"
          >
            阅读更多
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}